var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan"},[_vm._m(0),_c('div',{staticClass:"bottomUl"},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm.data.safeguardItems))]),_c('li',[_vm._v(_vm._s(_vm.data.amountInsured))]),_c('li',[_c('p',[_vm._v(_vm._s(_vm.data.scopeApplication))])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topUl"},[_c('ul',[_c('li',[_vm._v("保障项目")]),_c('li',[_vm._v("保障金额")]),_c('li',[_vm._v("保障范围")])])])
}]

export { render, staticRenderFns }